import styled from "styled-components";

export const Photo = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
`;

export const InfoTitle = styled.span`
  font-weight: 700;
  font-size: 18px;
  color: var(--neutral);
`;

export const InfoText = styled.p`
  font-weight: 300;
  font-size: 18px;
  color: var(--neutral);
  margin: 8px 0px;
`;